import React from 'react';

const Header = () => {
    return (
        <>
            <header className='py-3 text-center bg-info text-white mb-4'>
            <h1>Google Keep</h1>
            </header>
        </>
    );

};

export default Header;
